export default {
    url: 'members-store',
    include: ['us', 'ca'],
};
